import { useEffect, useState } from "react";
const Ranking = () => {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    fetch(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vSgVUFECN0wdkdDXbPXc8JReK7rsC-ik4ImTx5KaSdouXfP8CzlCageEK1modlYRQv0N39XLrSTxns3/pub?output=csv"
    )
      .then((res) => res.text())
      .then((text) => {
        const rows = text.trim().split("\n");
        const parsed = rows.map((row) => {
          const [name, score] = row.split(",");
          return { name, score: Number(score) };
        });
        setRanking(parsed);
      });
  }, []);
  return (
    <>
      <div className="ranking-top3">
        {/* 1位 */}
        <div className="top-card rank-1">
          <div className="rank-badge">1位</div>
          <h2>{ranking[0]?.name}</h2>
          <p className="score">{ranking[0]?.score.toLocaleString()} 枚</p>
        </div>

        {/* 2位 */}
        <div className="top-card rank-2">
          <div className="rank-badge">2位</div>
          <h2>{ranking[1]?.name}</h2>
          <p className="score">{ranking[1]?.score.toLocaleString()} 枚</p>
        </div>

        {/* 3位 */}
        <div className="top-card rank-3">
          <div className="rank-badge">3位</div>
          <h2>{ranking[2]?.name}</h2>
          <p className="score">{ranking[2]?.score.toLocaleString()} 枚</p>
        </div>
      </div>

      <div className="ranking-rest">
        {ranking.slice(3).map((item, index) => (
          <div key={index} className="ranking-item">
            <span className="rank">{index + 4} 位</span>
            <div className="info">
              <h3>{item.name}</h3>
              <p className="score">{item.score.toLocaleString()} 枚</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default Ranking;
